var PageController = require("app/core/PageController"),
    PageView       = require("./PageView"),
    deepEqual      = require("fast-deep-equal"),
    kind           = require("enyo/kind");

module.exports = kind(/** @lends  app.OopsPage.PageController.prototype */ {

    /**
     * @private
     */
    name: "app.OopsPage.PageController",

    /**
     * @private
     */
    kind: PageController,


    /**
     * Implement the logic for loading and displaying the page here.
     *
     * @param  {Object}    activation           The activation object
     * @param  {Object}    activation.params    Parameters to tell us what to do
     * @param  {boolean}   activation.finished  Flag if activation is finished
     * @param  {function}  activation.resolve   A promise resolver to fire when
     *                                          the page is active.
     * @param  {function}  activation.reject    A promise rejector to fire when
     *                                          the page failed to activate.
     * @public
     */
    execute: function(activation) {
        this.updateState(activation.params);
        this.updateView(PageView);
        this.updateDocumentTitle();
        activation.resolve(1);
    },

    /**
     * @param  {Object}  params  The params passed to this controller
     * @private
     */
    updateState: function(params) {
        var state = {};

        state.params = params;

        // Update state only if it actually changed
        if (!deepEqual(this.state, state)) {
            this.set("state", state);
        }

        // Broadcast state changes to app state
        this.app.$.state.set("pageMediaType", null);
        this.app.$.state.set("pageMediaSlug", null);
        this.app.$.state.set("pageMediaId", null);
    },

    /**
     * Update the document title.
     *
     * @private
     */
    updateDocumentTitle: function() {
        var i18nService = this.app.$.i18nService;

        if (this.app.get("documentTitleOwner") !== this) {
            return;
        }

        this.app.setDocumentTitle(i18nService.getString("app.OopsPage.Document.title"));
    }

});
